// -----------------------------------------------------------------
// <copyright
//   file="Izenda.ConnectionMasterPopup.js"
//   company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// -----------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import connect from 'share/enhancers/Izenda.Connect';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import localizer from 'share/localization/Izenda.Localizer';
import ConnectionMasterDbList from './Izenda.ConnectionMasterDbList';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';

/**
 * New connection master popup component.
 */
@connect()
class ConnectionMasterPopup extends Component {

  static propTypes = {
    connectionStore: PropTypes.object.isRequired
  };

  /**
   * Success + close modal.
   */
  doAccept = (dbType) => {
    const { props } = this;
    props.connectionStore.item.setServerTypeId(dbType.id);
    props.onAccept(true);
  };

  /**
   * Standard popup closing handler
   */
  onClosing = (callBack, type) => {
    const { props } = this;
    if (type === 'accept') {
      this.doAccept();
    } else {
      props.onReject('Cancel');
    }
  };

  /**
   * DbType selected handler
   * @param dbType
   */
  onDbTypeSelected = dbType => {
    this.doAccept(dbType);
  };

  /**
   * Render select db type control
   */
  renderDbTypeList() {
    const { props } = this;
    const { dbTypeList } = props.connectionStore;
    return (
      <ConnectionMasterDbList
        dbTypes={dbTypeList}
        onDbTypeSelected={this.onDbTypeSelected}/>
    );
  }

  render() {
    return (
      <Popup visible onClosing={this.onClosing} type="none" autoClose={false}
             sizeClass="izenda-ConnectionMaster-popup-size">
        <Popup.Header title={localizer.getText('CONNECTION_MASTER_POPUP_TITLE')}/>
        <Popup.Body>
          <div className="izenda-ConnectionMaster-content">
            <ScrollBox autoHeight autoHeightMax={475} autoHeightMin={475} fullWidth={true}>
              {this.renderDbTypeList()}
            </ScrollBox>
          </div>
        </Popup.Body>
        <Popup.Footer>
          {/*Cancel button*/}
          <Popup.ConfirmationButton type="cancel">
            {localizer.getText('COMMON_LABEL_CANCEL')}
          </Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}

ConnectionMasterPopup.$popupName = 'ConnectionMasterPopup';
export default ConnectionMasterPopup;



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Connection/ConnectionMaster/Izenda.ConnectionMasterPopup.js